// extracted by mini-css-extract-plugin
module.exports = {"bookEnd":"BookEnd_bookEnd__03_YT","content":"BookEnd_content__nyy1p","container":"BookEnd_container__ubcoM global_grid__4e_JW"};